if (!customElements.get('video-container')) {
  class Player extends HTMLElement {
    constructor() {
      super();
      this.video = this.querySelector('video');
      this.parentElm = this.closest('[data-video-wrapper]');
      this.overlay = this.parentElm?.querySelector('[data-overlay]');
      this.contentWrapper = this.parentElm?.querySelector('[data-content-wrapper]');
      this.playButton = this.querySelector('[data-play-button]');
      this.videoControls = this.parentElm?.dataset.videoControls;
    }

    connectedCallback() {
      // Bind event listeners
      if (this.videoControls !== 'true') {
        this.initEventListeners();
      }
    }

    initEventListeners() {
      // Custom play button click
      this.playButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.start();
      });

      // Video click to play/pause
      this.video.addEventListener('click', (e) => {
        e.preventDefault();
        this.toggleVideo();
      });

      // Video play/pause events
      this.video.addEventListener('play', () => this.updateUI(true));
      this.video.addEventListener('pause', () => this.updateUI(false));

      // Overlay click, if present
      if (this.overlay) {
        this.overlay.addEventListener('click', (e) => {
          e.preventDefault();
          this.toggleVideo();
        });
      }
    }

    // Start video playback and pause other videos
    start() {
      document.querySelectorAll('video-container').forEach((el) => {
        if (el === this) return;
        el.resetVideo();
      });

      this.video.play();
      this.updateUI(true);
    }

    // Toggle play/pause for the video
    toggleVideo() {
      if (this.video.paused) {
        setTimeout(() => {
          this.video.play();
        }, 100); // Delay to avoid race condition
      } else {
        this.video.pause();
      }
    }

    // Update UI based on play/pause state
    updateUI(isPlaying) {
      const action = isPlaying ? 'add' : 'remove';
      this.playButton.classList[action]('hidden');
      this.contentWrapper?.classList[action]('hidden');
      this.overlay?.classList[action]('hidden');
    }

    // Reset video state
    resetVideo() {
      this.video.load();
      this.video.pause();
      this.updateUI(false);
    }
  }

  window.Player = Player;
  customElements.define('video-container', Player);
}

if (!customElements.get('mini-player')) {
  customElements.define(
    'mini-player',
    class MiniPlayer extends HTMLElement {
      constructor() {
        super();
        // Get the video element
        this.video = this.querySelector('video');
      }

      connectedCallback() {
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.video.play();
              } else {
                this.video.pause();
              }
            });
          },
          {
            threshold: 0.5,
          }
        );

        // Start observing the element
        this.observer.observe(this);
      }

      // Stop observing the element when it's removed
      disconnectedCallback() {
        this.observer.unobserve(this);
      }
    }
  );
}
